const API_CONFIG = {
  // Production API Gateway URL
  BASE_URL: 'https://ttlmgw1s19.execute-api.eu-west-1.amazonaws.com/prod',
  ENDPOINTS: {
    IMAGES: '/images',
    UPLOAD: '/images',  // Same as IMAGES for upload functionality
    IMAGE_BY_ID: '/images/{id}', // Endpoint for getting a single image by ID
    SPONSORS: '/sponsors',
    MATCHES: '/matches',  // Now consistent with other endpoints
    PLAYERS: '/players',
    BATCH: '/batch'
  },
  DEFAULT_TENANT_ID: '1'
};

// Always use production API
export const API_BASE_URL = API_CONFIG.BASE_URL;

export default API_CONFIG;




























































































